import {
  IconButton,
  IconButtonProps,
  makeStyles,
  Tooltip,
} from "@material-ui/core";
import { SvgIconComponent } from "@material-ui/icons";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.secondary.contrastText,
    "&$disabled": {
      // todo: could this colour be driven from the theme?
      color: theme.palette.grey.A200,
    },
  },
  disabled: {},
  text: {
    textTransform: "uppercase",
    fontSize: "0.6em",
    display: "inline-block",
    marginTop: 3,
  },
}));

export type AppBarButtonProps = IconButtonProps & {
  tooltip?: string;
  text?: string;
  Icon?: SvgIconComponent;
  disabled?: boolean;
};

export const AppBarButton: React.FC<AppBarButtonProps> = ({
  tooltip,
  text = "",
  Icon,
  disabled,
  ...props
}) => {
  const classes = useStyles();

  return (
    <ToolTipSwitch tooltip={tooltip || text} disabled={!!disabled}>
      <IconButton
        disabled={disabled}
        {...props}
        classes={{
          root: classes.root,
          disabled: classes.disabled,
        }}
      >
        {Icon ? (
          <>
            <Icon />
            {/* &nbsp; */}
          </>
        ) : null}

        {text ? <Label text={text} /> : null}
      </IconButton>
    </ToolTipSwitch>
  );
};

const Label: React.FC<{ text: string }> = ({ text }) => {
  const classes = useStyles();

  return <span className={classes.text}>{text}</span>;
};

const ToolTipSwitch: React.FC<{
  disabled: boolean;
  tooltip: string;
  children: React.ReactElement<any, any>;
}> = ({ children, disabled, tooltip }) => {
  return !disabled ? (
    <Tooltip title={tooltip}>{children}</Tooltip>
  ) : (
    <span>{children}</span>
  );
};
